import { useEffect, useRef, useState } from "react";

export function usePoll(fetcher, ms, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [nonce, setNonce] = useState(0);
  const fRef = useRef(fetcher);
  fRef.current = fetcher;

  useEffect(() => {
    let alive = true;
    let timer;
    const run = async () => {
      try {
        const d = await fRef.current();
        if (alive) {
          setData(d);
          setError(null);
        }
      } catch (e) {
        if (alive) setError(e);
        // one-shot fetches retry while the backend is switching modes / syncing (503)
        if (alive && !ms && e?.response?.status === 503) timer = setTimeout(run, 3000);
      }
      if (alive && ms) timer = setTimeout(run, ms);
    };
    run();
    return () => {
      alive = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, nonce, ms]);

  useEffect(() => {
    // data mode switched (live <-> simulated): drop stale rows and refetch immediately
    const onMode = () => { setData(null); setNonce((n) => n + 1); };
    window.addEventListener("mdb-mode", onMode);
    return () => window.removeEventListener("mdb-mode", onMode);
  }, []);

  return { data, error, refresh: () => setNonce((n) => n + 1) };
}
